export const NavBarButtons = [
    {
        title: 'Collections'
    },
    {
        title: 'Men'
    },
    {
        title: 'Women'
    },
    {
        title: 'About'
    },
    {
        title: 'Contact'
    },
]